import styles from './HomeContent.module.scss'
import logoImg from '../images/logo.svg'

import PropTypes from 'prop-types'
import React from 'react'
import Button from './Button'

const HomeContent = ({ onStartPress }) => (
  <div className={styles.wrapper}>
    <img src={logoImg} />
    <div className={styles.main}>
      <h1>Quanto custa um site?</h1>
      <Button className={styles.button} onClick={onStartPress}>
        Descobrir
      </Button>
    </div>
  </div>
)

HomeContent.propTypes = {
  onStartPress: PropTypes.func.isRequired,
}

export default HomeContent
